import { StorageListV2Translations } from "../../../pt-BR/place/storage/storage-list-v2";

export const storageListV2: StorageListV2Translations = {
	layout: {
		title: "Storages",
	},
	header: {
		searchPlaceHolder: "Search by storage name",
		createStorage: "Create Storage",
		storageTypeFilter: {
			local: "Local",
			central: "Global",
			all: "All storages (central and local)",
			ariaLabel: "Select the storage type",
		},
	},
	indicators: {
		storagesCount: {
			label: "Registered storages",
		},
		productsCount: {
			label: "Products in storage",
		},
		totalCost: {
			label: "Storage cost",
		},
		zeroedProductsCount: {
			label: "Zeroed products",
			seeProducts: "See products",
		},
		productsWithoutUnitCostValue: {
			label: "Products without unit cost",
			seeProducts: "See products",
		},
	},
	list: {
		productsCount_zero: "{{count}} products",
		productsCount_one: "{{count}} product",
		productsCount_other: "{{count}} products",
		createdAt: "Created on {{date}}",
		productsCount: "In storage",
		totalCost: "Total cost",
		attachedBars_zero: "{{count}} linked bars",
		attachedBars_one: "{{count}} linked bar",
		attachedBars_other: "{{count}} linked bars",
		seeBars: "View bars",
		noBarsLinked: "No bars linked",
	},
	attachedBarsDrawer: {
		drawerTitle: "Bars linked",
		title: "Bars",
		description: "See where your product is available for consumption",
		linkedBarsLabel: "Linked bars",
		barDescription: {
			storage: "Storage",
			printersIps: "Printers IPs",
		},
	},
	irregularProductsDrawer: {
		filters: {
			storage: "Storage",
			selectStorage: "Select storage",
		},
		quantity: {
			title: "Products with zero quantity",
			description: "Update your products with zero quantity",
			save: "Update quantity",
		},
		unitCostValue: {
			title: "Products with zero unit cost",
			description: "Update your products with zero unit cost",
			save: "Update unit cost",
		},
		table: {
			columns: {
				product: "Product",
				fiscalCode: "SKU",
				storage: "Storage",
				quantity: "Quantity",
				unitCostValue: "Unit cost",
				totalCost: "Total cost",
			},
		},
		successUpdateIrregularProducts: "Products updated successfully",
	},
	actions: {
		editStorage: "Edit storage",
		deleteStorage: "Delete storage",
	},
	persistStorageDrawer: {
		title: {
			create: "Create storage",
			edit: "Edit storage",
		},
		form: {
			name: {
				label: "Storage name",
				placeholder: "Storage name",
				error: "Storage name is required",
				maxLengthError:
					"The storage name must have a maximum of {{maxLength}} characters",
				nameInUse: "Storage name already in use",
			},
			type: {
				label: "Storage type",
				options: {
					local: "Local",
					central: "Global",
				},
			},
		},
		actions: {
			submitEdit: "Save changes",
			submitCreate: "Create Storage",
		},
		successEditModal: "Storage edited successfully",
		successCreateModal: "Storage created successfully",
	},
	modalDelete: {
		title: "Delete Storage",
		warningMessage: 'Are you sure you want to delete the "{{storageName}}" storage?',
		warningMessageStrong: "This action cannot be undone.",
		submit: "Delete",
		successDeleteModal: "Storage deleted successfully",
	},
};
